// src/utils/analytics.js
import ReactGA from "react-ga4";

const TRACKING_ID = "G-8T6CFFCXDW"; // Replace with your GA4 Tracking ID

// Initialize GA
export const initGA = () => {
  ReactGA.initialize(TRACKING_ID);
};

// Track page views
export const trackPageView = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};

// Track custom events (optional)
export const trackEvent = (category, action, label = "") => {
  ReactGA.event({ category, action, label });
};
